<template>
  <b-modal
    id="upload-app-icon-modal"
    title="Upload App Icon"
    no-close-on-backdrop
  >
    <div id="image-cropper" class="mt-2 border mx-auto">
      <croppa
        v-model="cropper"
        @new-image-drawn="onNewImageDrawn"
        @zoom="onZoom"
        :width="125"
        :height="125"
        placeholder="Choose an image"
        :show-remove-button="true"
        :placeholder-font-size="14"
        remove-button-color="#ff8828"
        accept="image/*"
      >
      </croppa>
    </div>
    <div class="mx-auto mt-2">
      <input
        type="range"
        @input="onSliderChange"
        :min="sliderMin"
        :max="sliderMax"
        :step="sliderStep"
        v-model="sliderVal"
        class="custom-range"
      />
    </div>
    <div slot="modal-footer">
      <b-button
        variant="secondary"
        @click="$root.$emit('bv::hide::modal', 'upload-app-icon-modal')"
        class="mr-1"
      >
        Cancel
      </b-button>
      <b-button variant="primary" @click="onSave" class="ml-1"> Save </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "UploadAppIconModal",
  data() {
    return {
      cropper: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      sliderStep: ".001",
      base64Image: null,
    };
  },
  computed: {
    ...mapState("designs", ["appIcon"]),
  },
  methods: {
    ...mapMutations("designs", ["setAppIcon"]),
    onNewImageDrawn() {
      this.sliderVal = this.cropper.scaleRatio;
      this.sliderMin = this.cropper.scaleRatio / 2;
      this.sliderMax = this.cropper.scaleRatio * 2;
    },
    onZoom() {
      this.sliderVal = this.cropper.scaleRatio;
    },
    onSliderChange(evt) {
      let increment = evt.target.value;
      this.cropper.scaleRatio = +increment;
    },
    onSave() {
      this.setAppIcon(this.cropper.generateDataUrl());
      this.$root.$emit("bv::hide::modal", "upload-app-icon-modal");
    },
  },
  watch: {
    appIcon(val) {
      if (!val) this.cropper.remove();
    },
  },
};
</script>

<style>
</style>